var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup39(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_39",
    "data-name": "Group 39",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.101,
    height: 35.101,
    viewBox: "0 0 35.101 35.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M6115.836,94.944a17.55,17.55,0,1,1,17.552-17.552A17.57,17.57,0,0,1,6115.836,94.944Zm0-33.912A16.362,16.362,0,1,0,6132.2,77.392,16.378,16.378,0,0,0,6115.836,61.032Z",
    transform: "translate(-6098.288 -59.843)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(9.499 14.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 3.305,
    height: 10.577
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(9.072 9.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M6107.915,71.144h-.024a1.835,1.835,0,0,1-1.973-1.833,2.014,2.014,0,1,1,2,1.833Z",
    transform: "translate(-6105.918 -67.474)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(14.822 13.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M6121.961,82.267h-3.747V76.794c0-1.433-.586-2.41-1.876-2.41a1.893,1.893,0,0,0-1.789,1.295,2.459,2.459,0,0,0-.081.865v5.723h-3.713s.049-9.7,0-10.577h3.713v1.66a3.39,3.39,0,0,1,3.3-1.762c2.349,0,4.193,1.522,4.193,4.8Z",
    transform: "translate(-6110.755 -71.588)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup39);
export default __webpack_public_path__ + "static/media/Group 39.1097dd47a0f741288dd180b8171da140.svg";
export { ForwardRef as ReactComponent };